// 开发环境服务器端地址
const server = '/rsales'
// ============================ layout布局===========================
// 登录
const login = server + '/logIn/tologin'
// 退出
const logout = server + '/logIn/signout'
// 菜单列表
const menu = server + '/menuinfo/data?menuLevel=1'
// // 获取角色信息
const getRole = server + '/personalHomePage/getCurrentUserRole'
// 获取角色权限
const getRolebtn = server + '/functioninfo/queryPermitForCurrentUser'
// =================================主页=============================
// 获取顶部搜索list
const searchDataList = server + '/personalHomePage/getQueryArea'
// 获取Echarts图数据
const getChartsData = server + '/personalHomePage/getManagerData'
// 漏斗图数据穿透table
const chuantouTable = server + '/personalHomePage/getAllResume'
// 饼图数据穿透table
const bingtuTable = server + '/personalHomePage/getStaffList'
// 获取渠道类别数据
const getChannelinfoData = server + '/sys/getCodelist?codetype=qdtype'
// 获取渠道名称数据
const getChanneNameData = server + '/channelinfo/data'
// 获取简历专员数据
const getresumeCollectingData = server + '/personalHomePage/getResumeRank'
// 获取电话销售数据
const getphoneCollectingData = server + '/personalHomePage/getPhoneSalerRank'
// 获取咨询顾问数据
const getcounselorCollectingData =
    server + '/personalHomePage/getFacingSalerRank'
    // 获取咨询顾问数据
const getmessageCollectingData = server + '/personalHomePage/getInterRank'
// 获取线下专员数据
const getUnderLineData = server + '/personalHomePage/getUnderLineData'
// ============================ 系统设置==============================
// 行政组织 -- 查询
const orgTree = server + '/departmentinfo/getAdministrativeOrganization'
// 行政组织同步 -- 按钮
const synchronousButton = server + '/JobManager/tiggerJob'
// 业务组织--查询
const businessOrg = server + '/organization/getBusinessOrganizationTree'
// 业务同步--按钮
const busSynchOrg = server + '/JobManager/tiggerJob'
// 人员角色管理--列表
const personList = server + '/staffInfo/paggingAuthcSaler'
// 人员角色管理-分配角色弹窗-select列表
const roleList = server + '/role/getAuthcRole'
// 人员角色管理--修改人员角色保存
const updateRole = server + '/role/setAuthcRole'
// 角色分配--列表
const roleListAll = server + '/role/paggingData'
// 角色分配--编辑--菜单树数据
const roleMenuList = server + '/menuinfo/AllDataWithAuthc'
// 角色分配--编辑-查询菜单中按钮
const roleMenuBtn = server + '/functioninfo/queryPermitForRole'
// 角色分配--编辑--菜单树数据--保存角色已分配菜单
const roleMenuListSave = server + '/role/setRoleMenuPermit'
// 角色分配--编辑--功能按钮--保存角色已分配按钮
const savepermit = server + '/functioninfo/savepermit'
// 功能管理--列表
const functionManagementList = server + '/functioninfo/paggingData'
// 功能管理--保存
const functionManagementsave = server + '/functioninfo/save'
// 数据同步
const DataSyn = server + '/JobManager/tiggerJob'
// 数据同步列表
const DataSynList = server + '/JobManager/getJobList'
// 数据同步立即执行
const runJobNow = server + '/JobManager/runJobNow'
// 数据同步-新增
const createJob = server + '/JobManager/createJob'
// 数据同步-暂停任务
const pauseTrigger = server + '/JobManager/pauseTrigger'
// 数据同步-启动任务
const resumeTrigger = server + '/JobManager/resumeTrigger'
// 信息分配管理-ttc---人员角色管理业务组织复用
const getCurrentUserAdminAuth = server + '/staffInfo/getCurrentUserAdminAuth'
// 信息分配管理-渠道分类
const getQueryArea = server + '/personalHomePage/getQueryArea'
// 信息分配管理-电销人员列表
const getPhoneSalerByTTC = server + '/staffInfo/getPhoneSalerByTTC'
// 信息分配管理-分配保存接口
const allocatePhoneSalerByTTC = server + '/staffInfo/allocatePhoneSalerByTTC'
// ============================ 渠道管理============================================
// 渠道信息--列表
const channelInfoList = server + '/channelinfo/paggingData'
// 渠道账号--列表
const channelAccountList = server + '/channelAccount/paggingData'
// 渠道账号--分配人员列表
const distributionList = server + '/staffInfo/paggingAuthcData'
// 渠道账号-分配-保存账号分配人
const setAccountUser = server + '/channelAccount/setAccountUser'
// 渠道账号-分配-获取当前账号使用人
const getAccountUser = server + '/channelAccount/getAccountUser'
// 渠道账号-分配-新增/修改
const saveAccount = server + '/channelAccount/save'
// 渠道账号-分配-获取角色列表
const getRoleList = server + '/role/data'
// 渠道账号--修改--获取渠道select数据
const getChannlNameList = server + '/channelinfo/data'
// 渠道账号--修改--获取渠道select数据（新）
const getChannlNameListNew = server + '/channelinfo/AllChannel'
// 渠道账号--修改--获取渠道是否能修改
const Isupdatechannel = server + '/channelAccount/checkCanBeUpdateChannelId'
// 渠道信息/渠道账号--获取ttc
const getTTCList = server + '/channelAccount/getTTCOrganizationList'
// 渠道信息/账套
const getZT = server + '/sys/getZT'
// 渠道信息/删除账套
const delRsalesContract = server + '/channelAccount/delRsalesContract'
// ============================ 机会学员管理===================
// 机会学员录入/导入--简历量-列表 origin=1 传参 //学员到访 origin=3 (混乱接口)
const resumeList = server + '/resumeInfo/data'
// 机会学员-学员查找列表
const studentQuery = server + '/resumeInfo/fastSelectResumeList'
// 机会学员-学员查找导出
const exportExcelXYCZ = server + '/resumeInfo/exportExcelXYCZ'
// 机会学员-高级学员查找编辑
const selectResumeUpdateGJ =
    server + '/highGradeResumeSearch/selectResumeUpdateGJ'
    // 机会学员-高级学员查找编辑保存
const updateHighGradeResumeInfo =
    server + '/highGradeResumeSearch/updateHighGradeResumeInfo'
    // 机会学员-高级学员查找删除
const DelAllResume = server + '/highGradeResumeSearch/DelAllResume'
// 机会学员-高级学员查找获取电销
const getAllPhoneSaler = server + '/staffInfo/getAllPhoneSaler'
// 机会学员-高级学员查找获取顾问
const getAllFacingSaler = server + '/staffInfo/getAllFacingSaler'
// 机会学员-高级学员二级渠道
const getAllAccountList = server + '/channelAccount/getAllAccountList'
// 机会学员-高级学员二级渠道
const getAllSecondChannelList = server + '/sys/getAllSecondChannelList'
// 机会学员录入-简历量列表
const resumenListNew = server + '/resumeInfo/dataNew'
// 机会学员录入-简历量TTC
const getResumeTTClist = server + '/staffInfo/getQueryTTC'
// 机会学员录入-简历量新增-渠道账号
const getAccountListWithOrg = server + '/resumeInfo/getAccountListWithOrg'
// 机会学员录入/导入--简历量-弹窗list接口//根据传参不同数据不同
const getCodelist = server + '/sys/getCodelist'
// 机会学员录入/导入 -- 信息量 -获取TTC列表数据
const GetTTclist = server + '/staffInfo/getAuthcTTC'
// 学员查找复用--学员到访计划复用
const getinfomationTTClist = server + '/staffInfo/getQueryTTC'
// 机会学员录入/导入--简历量-弹窗渠道list接口//
const getChannelList = server + '/resumeInfo/getSourseList'
// 机会学员录入/导入--信息量-弹窗渠道list接口//
const getChannelListxinxi = server + '/infoAmount/getSourseList'
// 机会学员录入/导入--简历量-弹窗渠道账号list接口//传渠道ID参数
const getAccountList = server + '/resumeInfo/getAccountList'
// 机会学员录入/导入--简历量-新增后保存
const resumeAddSave = server + '/NewresumeInfo/insertResumeInfo'
// 机会学员录入/导入--简历量-修改后保存
const resumeUpdateSave = server + '/resumeInfo/updateResumeInfoJL'
// 机会学员录入/导入--简历量-导入上传接口
const resumeuploadTolead = server + '/resumeInfo/uploadResume'
// 机会学员录入/导入--简历量-模板下载
const exportResumeTemplet = server + '/resumeInfo/exportResumeTemplet'
// 机会学员录入/导入--简历量-对应电销接口
const getResumePhoneSalerByTTC = server + '/staffInfo/getQueryPhoneSalerWithTTC'
// 机会学员录入/导入--信息量-列表
const informationList = server + '/infoAmount/selectDataNew'
// 机会学员录入/导入--信息量-录入新增--保存
const informationAddSave = server + '/infoAmount/insertResumeInfo'
// 机会学员录入/导入--信息量-修改后保存
const informationUpdateSave = server + '/infoAmount/updateInfo'
// 机会学员录入/导入--信息量-导入上传接口
const informationuploadTolead = server + '/infoAmount/uploadInfoAmount'
// 机会学员录入/导入--信息量-对应电销接口
const getInfoPhoneSalerByTTC = server + '/staffInfo/getInfoPhoneSalerByTTC'
// 机会学员录入/导入--信息量-对应电销下移接口
const orderPhoneSalerByTTC = server + '/staffInfo/orderPhoneSalerByTTC'
// 机会学员录入/导入--模糊-状态获取  //复用学员查找
const getStatusList = server + '/sys/getDistinctStatus'
// 机会学员-线下推荐列表
const underResumeList = server + '/underResumeInfo/dataNew'
// 机会学员录入--线下-录入新增
const underLineAddSave = server + '/underResumeInfo/saveUnderResume'
// 机会学员录入--线下-保存
const updateUnderResume = server + '/underResumeInfo/updateUnderResume'
// 机会学员录入--线下-获取毕业学校
const getSchoolList = server + '/sys/getSchoolList'
// 机会学员录入--线下-获取tab逾期
const getUnderCount = server + '/underResumeInfo/getUnderCount'
// 机会学员录入--线下-状态编辑保存
const saveUnderStatus = server + '/underResumeInfo/phoneSalerSaveInterview'
// 机会学员录入--线下-捞人列表
const underLineSalvage =
    server + '/underResumeInfo/queryWaitingUnderForPhoneSalerNew'
    // 机会学员录入--线下-捞人保存
const saveInterIn = server + '/underResumeInfo/saveInterIn'
// 机会学员录入--线下-编辑信息来源
const getXxlyList = server + '/underResumeInfo/getXxlyList'
// 机会学员录入--简历信息线下录入，电话校验
const checkPhoneNum = server + '/sys/checkPhoneNum'
// 电销沟通记录--简历量-列表
const telresumeList =
    server + '/resumeInfo/personaldata?lifterType=2&origin=1&pooltype=1'
    // 电销沟通记录--简历量-捞人列表
const telResumegetStudentList =
    server + '/resumeInfo/queryWaitingForPhoneSalerNew?origin=1'
    // 电销沟通记录--简历量-一键捞入
const oneKeySalvage = server + '/resumeInfo/oneKeySalvage'
// 电销沟通记录--信息-一键捞入
const oneKeySalvageInfo = server + '/infoAmount/oneKeySalvageInfo'
// 电销沟通记录--简历量-捞人保存 =========================信息量复用此接口
const gainSavestudent = server + '/resumeInfo/insertDistribute'
// 电销沟通记录--简历量-历史记录 =========================信息量复用此接口
const resumeHistory = server + '/resumeInfo/getHistoryList'
// 电销沟通记录--简历量-状态保存 =========================信息量复用此接口
const saveStatus = server + '/interview/phoneSalerSaveInterview'
// 电销沟通记录--简历量-tab提示待上门数量 =========================信息量复用此接口
const tabHint = server + '/resumeInfo/getWaitForArrive'
// 电销沟通记录--备注保存接口 =========================简历量信息量顾问面访记录复用此接口 pageFlag 1-电销 2-咨询顾问
const updateRemarks = server + '/resumeInfo/updateRemarks'
// 电销沟通记录--简历量-简历保存
const updateResumeInfoJLDX = server + '/resumeInfo/updateResumeInfoJLDX'
// 电销沟通记录--信息量-简历保存
const updateInfoDX = server + '/infoAmount/updateInfoDX'
// 电销沟通记录--信息量-列表
const TelinformationList =
    server + '/resumeInfo/personaldata?lifterType=2&origin=2&pooltype=1'
    // 电销沟通记录--信息量-捞人列表
const informationgetStudentList =
    server + '/infoAmount/queryWaitingInfoForPhoneSalerNew?origin=2'
    // 学员到访--列表
const studentVisitList = server + '/resumeInfo/signDataNew'
// 学员到访--签到接口
const resumeSign = server + '/resumeInfo/updateResumeSign'
// 学员到访--取消签到接口
const cancelSign = server + '/resumeInfo/cancelSign'
// 学员到访--状态接口
const studentStatusList = server + '/sys/getCodelist?ext2=6'
// 到访计划--列表
const visitPlanList = server + '/resumeInfo/visitDataNew'
// 到访计划--逾期数量
const lateVisitCount = server + '/resumeInfo/lateVisitCountNew'
// 到访计划--补签
const supplementSign = server + '/resumeInfo/supplementSign'
// 面访记录--列表
const interviewList = server + '/resumeInfo/personaldata?pooltype=2'
// 获取面访记录收集状态
const getInterviewStatus = server + '/sys/getCodelist'
// 顾问捞人
const StudentList = server + '/resumeInfo/queryWaitingForFaceSalerNew'
// 顾问面访-捞人保存
const salvageStudent = server + '/resumeInfo/insertDistribute'
// 顾问面访--历史记录
const interviewHistory = server + '/resumeInfo/getHistoryList'
// 顾问面访---代缴费状态保存
const interviwSaveStatus = server + '/interview/faceSalerSave'
// 顾问面访---状态保存
const faceSalerSaveInterview = server + '/interview/faceSalerSaveInterview'
// 顾问面访-信息修改后保存
const interviewUpdateSave = server + '/resumeInfo/updateResumeInfoMF'
// 顾问面访-保存校验身份证号
const checkIdNo = server + '/interview/checkIdNo'
// 顾问面访-代缴费修改保存
const updateWaitPay = server + '/interview/updateWaitPay'
// 顾问面访-代缴费改为待上门
const phoneSalerSaveInterview = server + '/interview/phoneSalerSaveInterview'
// 顾问面访-获取项目table数据
const xiangmulist = server + '/xmxxSync/paggingData'
// 顾问面访-待缴费接口--项目显示
const getLhszm = server + '/sys/getSetupSign'
// 顾问面访-待缴费身份证校验--线下复用
const checkIdcardNo = server + '/sys/checkIdcardNo'
// 顾问面访-待缴费--是否已经在睿营缴费
const checkPayed = server + '/interview/checkPayed'
// 获取面访记录贷款账套
const getInterviewZT = server + '/sys/getCodelist'
// 缴费跟踪-待缴费列表
const queryDjfResume = server + '/jtfxxSync/queryDjfResume'
// 缴费跟踪-成单列表
const queryCdResume = server + '/jtfxxSync/queryCdResume'
// 学员查找--状态接口
const studentQueryStatusList = server + '/sys/getCodelist'

// ============================ 数据统计===================
// 数据统计--业务统计--网资专员
const teamStatisticsByInternet =
    server + '/teamStatistics/getTeamStatisticsByInternet'
    // 数据统计--业务统计--简历专员
const teamStatisticsByResume =
    server + '/teamStatistics/getTeamStatisticsByResume'
    // 数据统计--业务统计--电话销售
const teamStatisticsByTelephone =
    server + '/teamStatistics/getTeamStatisticsByTelephone'
    // 数据统计--业务统计--面访顾问
const teamStatisticsByFacing =
    server + '/teamStatistics/getTeamStatisticsByFacing'
    // 数据统计--业务统计--网资有效量穿透
const selYxFromTeamTjInternet = server + '/statisticsTJ/selYxFromTeamTjInternet'
// 数据统计--业务统计--网资上门量穿透
const selDatingFromTeamTjInternet =
    server + '/statisticsTJ/selDatingFromTeamTjInternet'
    // 数据统计--业务统计--网资成单量穿透
const selPayFromTeamTjInternet =
    server + '/statisticsTJ/selPayFromTeamTjInternet'
    // 数据统计--业务统计--简历有效量穿透
const selYxFromTeamTjResume = server + '/statisticsTJ/selYxFromTeamTjResume'
// 数据统计--业务统计--简历上门量穿透
const selDatingFromTeamTjResume =
    server + '/statisticsTJ/selDatingFromTeamTjResume'
    // 数据统计--业务统计--简历成单量穿透
const selPayFromTeamTjResume = server + '/statisticsTJ/selPayFromTeamTjResume'
// 数据统计--业务统计--信息沟通量穿透
const selXXGTFromTeamTjPhone = server + '/statisticsTJ/selXXGTFromTeamTjPhone'
// 数据统计--业务统计--简历沟通量穿透
const selJLGTFromTeamTjPhone = server + '/statisticsTJ/selJLGTFromTeamTjPhone'
// 数据统计--业务统计--信息上门量穿透
const selXXSMFromTeamTjPhone = server + '/statisticsTJ/selXXSMFromTeamTjPhone'
// 数据统计--业务统计--简历上门量穿透
const selJLSMFromTeamTjPhone = server + '/statisticsTJ/selJLSMFromTeamTjPhone'
// 数据统计--业务统计--面访量穿透
const selMFFromTeamTjFacing = server + '/statisticsTJ/selMFFromTeamTjFacing'
// 数据统计--业务统计--成单量穿透
const selCDFromTeamTjFacing = server + '/statisticsTJ/selCDFromTeamTjFacing'
// 数据统计--业务统计--已回款穿透
const selYHKFromTeamTjFacing = server + '/statisticsTJ/selYHKFromTeamTjFacing'
// 数据统计--业务统计--已退费穿透
const selYTFFromTeamTjFacing = server + '/statisticsTJ/selYTFFromTeamTjFacing'
// 数据统计--业务统计--线下列表
const getTeamStatisticsByUnder =
    server + '/teamStatistics/getTeamStatisticsByUnder'
    // 数据统计--业务统计--线下量穿透
const selXLLFromTeamTjUnder = server + '/statisticsTJ/selXLLFromTeamTjUnder'
// 数据统计--业务统计--线下上门量穿透
const selSMLFromTeamTjUnder = server + '/statisticsTJ/selSMLFromTeamTjUnder'
// 数据统计--业务统计--线下成单量穿透
const selCDLFromTeamTjUnder = server + '/statisticsTJ/selCDLFromTeamTjUnder'
// 数据统计--业务统计--待汇款穿透
const selWaitPayInFromTeamTj = server + '/statisticsTJ/selWaitPayInFromTeamTj'
// 数据统计--渠道统计
const channelStatisticsData =
    server + '/channelStatistics/getChannelStatisticsData'
    // 数据统计--渠道统计--渠道类型
const channelInfoByType = server + '/sys/getCodelist?codetype=qdtype'
// 数据统计--渠道统计--渠道名称
const getChannelIdList = server + '/channelinfo/data'
// 数据统计--渠道统计--上门量穿透数据
const visitQuantityList = server + '/statisticsTJ/selDatingFromChannelTj'
// 数据统计--渠道统计--成单量穿透数据
const singleQuantityList = server + '/statisticsTJ/selPayFromChannelTj'
// 数据统计--渠道统计--回款量穿透数据
const huikuanList = server + '/statisticsTJ/selPayInFromChannelTj'
// 数据统计--渠道统计--退费量穿透数据
const tuifeiList = server + '/statisticsTJ/selTfInFromChannelTj'
// 数据统计--渠道统计--待汇款穿透数据
const dhkList = server + '/statisticsTJ/selWaitPayInFromChannelTj'
// 渠道统计数据-个人主页-固化
const solidifyAllChannelStatisticsInfoData = server + '/StatisticsSolidifyAll/solidifyAllChannelStatisticsInfoData'
// 团队统计数据-简历专员-个人主页-固化
const solidifyAllResumeStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllResumeStatisticsData'
// 团队统计数据-网资专员-个人主页-固化
const solidifyAllInternetStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllInternetStatisticsData'
// 团队统计数据-电话销售-个人主页-固化
const solidifyAllTelephoneStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllTelephoneStatisticsData'
// 团队统计数据-面访顾问-个人主页-固化
const solidifyAllFacingStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllFacingStatisticsData'
// 团队统计数据-线下专员-个人主页-固化
const solidifyAllUnderStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllUnderStatisticsData'
// 渠道统计数据-固化
const solidifyAllChannelStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllChannelStatisticsData'
// 团队统计数据-简历专员-固化
const solidifyAllTJResumeStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllTJResumeStatisticsData'
// 团队统计数据-网资专员-固化
const solidifyAllTJInternetStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllTJInternetStatisticsData'
// 团队统计数据-电话销售-固化
const solidifyAllTJTelephoneStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllTJTelephoneStatisticsData'
// 团队统计数据-面访顾问-固化
const solidifyAllTJFacingStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllTJFacingStatisticsData'
// 团队统计数据-线下专员-固化
const solidifyAllTJUnderStatisticsData = server + '/StatisticsSolidifyAll/solidifyAllTJUnderStatisticsData'
export default {
  login,
  logout,
  menu,
  personList,
  roleListAll,
  roleList,
  checkIdNo,
  updateWaitPay,
  getRolebtn,
  getresumeCollectingData,
  updateRole,
  checkPayed,
  roleMenuList,
  GetTTclist,
  roleMenuBtn,
  chuantouTable,
  phoneSalerSaveInterview,
  roleMenuListSave,
  savepermit,
  searchDataList,
  oneKeySalvage,
  oneKeySalvageInfo,
  functionManagementList,
  functionManagementsave,
  channelInfoList,
  channelAccountList,
  distributionList,
  setAccountUser,
  getAccountUser,
  saveAccount,
  xiangmulist,
  getRoleList,
  getChannlNameList,
  getChannlNameListNew,
  bingtuTable,
  Isupdatechannel,
  resumeList,
  studentQuery,
  StudentList,
  informationList,
  TelinformationList,
  orgTree,
  synchronousButton,
  businessOrg,
  busSynchOrg,
  getTTCList,
  getRole,
  resumeUpdateSave,
  getCodelist,
  getChannelList,
  getUnderLineData,
  getAccountList,
  resumeAddSave,
  studentVisitList,
  resumeSign,
  cancelSign,
  visitPlanList,
  getChannelListxinxi,
  lateVisitCount,
  interviewList,
  getInterviewStatus,
  resumeuploadTolead,
  getinfomationTTClist,
  informationAddSave,
  informationUpdateSave,
  informationuploadTolead,
  getStatusList,
  telresumeList,
  telResumegetStudentList,
  resumenListNew,
  gainSavestudent,
  resumeHistory,
  queryDjfResume,
  queryCdResume,
  saveStatus,
  informationgetStudentList,
  salvageStudent,
  interviewHistory,
  interviewUpdateSave,
  tabHint,
  teamStatisticsByInternet,
  teamStatisticsByResume,
  teamStatisticsByTelephone,
  teamStatisticsByFacing,
  interviwSaveStatus,
  channelStatisticsData,
  channelInfoByType,
  getChannelIdList,
  getphoneCollectingData,
  getcounselorCollectingData,
  getmessageCollectingData,
  getChannelinfoData,
  getChanneNameData,
  getChartsData,
  visitQuantityList,
  singleQuantityList,
  underLineAddSave,
  getSchoolList,
  getUnderCount,
  underResumeList,
  saveUnderStatus,
  underLineSalvage,
  saveInterIn,
  huikuanList,
  tuifeiList,
  selYxFromTeamTjResume,
  selYxFromTeamTjInternet,
  selDatingFromTeamTjInternet,
  selPayFromTeamTjInternet,
  selDatingFromTeamTjResume,
  selPayFromTeamTjResume,
  selXXGTFromTeamTjPhone,
  selJLGTFromTeamTjPhone,
  selXXSMFromTeamTjPhone,
  selJLSMFromTeamTjPhone,
  selMFFromTeamTjFacing,
  selCDFromTeamTjFacing,
  selYHKFromTeamTjFacing,
  selYTFFromTeamTjFacing,
  getTeamStatisticsByUnder,
  selXLLFromTeamTjUnder,
  selSMLFromTeamTjUnder,
  selCDLFromTeamTjUnder,
  updateUnderResume,
  DataSyn,
  DataSynList,
  runJobNow,
  createJob,
  pauseTrigger,
  resumeTrigger,
  getXxlyList,
  getResumePhoneSalerByTTC,
  getInfoPhoneSalerByTTC,
  selectResumeUpdateGJ,
  DelAllResume,
  getAllPhoneSaler,
  getAllFacingSaler,
  getAllAccountList,
  getAllSecondChannelList,
  updateHighGradeResumeInfo,
  exportResumeTemplet,
  exportExcelXYCZ,
  updateResumeInfoJLDX,
  updateInfoDX,
  getResumeTTClist,
  getAccountListWithOrg,
  studentStatusList,
  updateRemarks,
  studentQueryStatusList,
  getLhszm,
  getInterviewZT,
  getQueryArea,
  getCurrentUserAdminAuth,
  getPhoneSalerByTTC,
  allocatePhoneSalerByTTC,
  orderPhoneSalerByTTC,
  checkPhoneNum,
  getZT,
  dhkList,
  delRsalesContract,
  supplementSign,
  solidifyAllChannelStatisticsInfoData,
  solidifyAllResumeStatisticsData,
  solidifyAllInternetStatisticsData,
  solidifyAllTelephoneStatisticsData,
  solidifyAllFacingStatisticsData,
  solidifyAllUnderStatisticsData,
  solidifyAllChannelStatisticsData,
  solidifyAllTJResumeStatisticsData,
  faceSalerSaveInterview,
  solidifyAllTJInternetStatisticsData,
  solidifyAllTJTelephoneStatisticsData,
  solidifyAllTJFacingStatisticsData,
  solidifyAllTJUnderStatisticsData,
  checkIdcardNo,
  selWaitPayInFromTeamTj
}



// WEBPACK FOOTER //
// ./src/api/index.js